import React from 'react';
import { PopupButton } from '@components/basics/PopupButton';
import { DataTestId } from '@utils/test';

export const getLabelText = (amount: number): string => {
  if (amount === 1) {
    return '1 new activity';
  } else {
    return `${amount?.toLocaleString()} new activities`;
  }
};

/**
 * This NewActivityButton will appear when there is at least 1 new activity
 * Pass refetch query + reset new acticity count as onClick to scroll up while refetching feed
 */
export const NewActivityButton = ({
  bottom = 10,
  newActivityCount,
  onClick,
  loading,
}: {
  bottom?: number;
  newActivityCount: number;
  onClick?: () => void;
  loading?: boolean;
}) => {
  const isVisible = newActivityCount > 0 && !loading;

  return (
    <PopupButton
      dataTestId={DataTestId.FEED_NEW_ACTIVITY_BUTTON}
      isVisible={isVisible}
      label={getLabelText(newActivityCount)}
      bottom={bottom}
      onClick={onClick}
      loading={loading}
    />
  );
};
